import { Ghost } from "lucide-react";
import { Alert, Card, Col, Row } from "react-bootstrap";

import "./styles.css";

export function NotFound() {
  return (
    <div
      className="d-flex justify-content-center align-items-center p-5 position-relative"
      style={{
        width: "100vw",
        height: "100vh",
        backgroundColor: "var(--background)",
      }}
    >
      <Card className="card_info d-flex flex-column justify-content-center align-items-center notFound_card">
        <Row className="d-flex flex-column justify-content-center align-items-center gap-3">
          <Col className="d-flex justify-content-center">
            <Alert className="">
              <Ghost size={48} strokeWidth={1.5} />
            </Alert>
          </Col>

          <Col className="text_container">
            <h1>404</h1>
            <p>Página Não Encontrada</p>
          </Col>

          <Col>
            <p className="subtitle text-center text_message">
              A página que você está procurando parece ter sido movida ou não
              existe mais.
            </p>
          </Col>

          <Col className="pt-5 border-top d-flex justify-content-center align-items-center gap-2 text-muted small font-bold text-uppercase">
            <div className="dot_icon"></div>
            Flex Consulta
          </Col>
        </Row>
      </Card>
    </div>
  );
}
